import { css } from '@emotion/react'
import { COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS } from '@/components/pages/companies/reducers/column'

export const DescriptionText = ({
  text,
  dataTestId,
}: {
  text?: string
  dataTestId: string
}) => {
  return (
    <td
      data-test-id={dataTestId}
      css={css`
        min-width: ${COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS.description
          ?.width}px;
        max-width: ${COLUMN_NAMES_WITH_STATUS_EARLY_ACCESS.description
          ?.width}px;
      `}
    >
      <span
        css={css`
          white-space: normal;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          width: 100%;
          line-height: 150%;
          word-break: break-word;
        `}
        title={text}
      >
        {text ? text : ''}
      </span>
    </td>
  )
}
